import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MateriaComentarioRespostaService } from '../../../../services/materia.comentarioresposta.service';

@Component({
  selector: 'app-adm-comentario-resposta',
  templateUrl: './adm-comentario-resposta.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdmComentarioRespostaComponent {
  constructor(
    private materiaComentarioRespostaService: MateriaComentarioRespostaService,
  ) { }

  @Input() comentarioId: number;

  comentarioRespondido: boolean;

  ngOnInit() {
    this.isResponded(this.comentarioId);
  }

  isResponded(idComentario: number) {
    this.materiaComentarioRespostaService
      .getCountByComentarioId(idComentario)
      .subscribe({
        next: (res:any) => {
          if (res > 0) {
            this.comentarioRespondido = true;
          } else {
            this.comentarioRespondido = false;
          }
        },
        error: () => {
          this.comentarioRespondido = false;
        },
      });
  }
}
